<template>
<div>
  <PageTitle :route="$route">
    <template
      slot="action-button"
    >
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <GroupsList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import GroupsList from '@/components/settings/users/groups/GroupsList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Groups',
  components: {
    PageTitle,
    PageRowWrapper,
    GroupsList,
    ActionButton
  },
  methods: {
    onClickButton () {
      this.$router.push({ name: 'addgroup' })
    }
  }
}
</script>
